import * as types from 'store/modules/hrms73e/mutation-types'
import { constLabels } from 'assets/js/constLabels.js'
import hrms73e from 'api/hrms73e'
import swal from 'sweetalert'
import hrms73eLabels from 'assets/labels/hrms73e'
import { hrms73eMaxRowspan, hrms73eColumns } from 'assets/columns/hrms73e'
import configLabel from 'src/../config/label'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    disableCodform: false,
    labels: hrms73eLabels,
    maxRowspan: hrms73eMaxRowspan,
    columns: hrms73eColumns(),
    index: {
      total: 0,
      rows: []
    },
    detail: {
      tab1: {
        detail: {
          codform: ''
        },
        table1: {
          total: 0,
          rows: []
        },
        table2: {
          total: 0,
          rows: []
        }
      }
    },
    indexSelected: {}
  },
  getters: {
    [types.GET_HRMS73E_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRMS73E_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRMS73E_MAX_ROWSPAN] (state) {
      return state.maxRowspan
    },
    [types.GET_HRMS73E_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRMS73E_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRMS73E_INDEX] (state) {
      return state.index
    },
    [types.GET_HRMS73E_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRMS73E_DETAIL] (state) {
      return state.detail
    },
    [types.GET_HRMS73E_DISABLE_CODFORM] (state) {
      return state.disableCodform
    }
  },
  mutations: {
    [types.SET_HRMS73E_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRMS73E_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRMS73E_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
      }
    },
    [types.SET_HRMS73E_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRMS73E_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRMS73E_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRMS73E_DETAIL] (state, data) {
      state.detail = data
      state.detail.tab1.detail.codform = data.tab1.detail.codform || ''
    },
    [types.SET_HRMS73E_DISABLE_CODFORM] (state, disableCodform) {
      state.disableCodform = disableCodform
    }
  },
  actions: {
    [types.TOGGLE_HRMS73E_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRMS73E_INDEX_DISP, indexDisp)
      commit(types.SET_HRMS73E_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRMS73E_COLUMNS_LABELS] ({ commit }) {
      hrms73e.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS73E_COLUMNS, data.labels)
          commit(types.SET_HRMS73E_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS73E_INDEX] ({ commit }, searchParams) {
      hrms73e.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS73E_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS73E_DETAIL] ({ commit }, { searchIndex, indexSelected }) {
      hrms73e.getDetail({ searchIndex, indexSelected })
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS73E_DETAIL, data)
          if (data.tab1.detail.codform !== '') {
            commit(types.SET_HRMS73E_DISABLE_CODFORM, true)
          } else {
            commit(types.SET_HRMS73E_DISABLE_CODFORM, false)
          }
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS73E_DETAIL_FORM] ({ commit }, detailFrom) {
      hrms73e.getDetailForm(detailFrom)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS73E_DETAIL, data)
          commit(types.SET_HRMS73E_DISABLE_CODFORM, true)
        })
        .catch((response) => {
          const data = response.response.data
          swal({
            title: '', text: data.response, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
          commit(types.SET_HRMS73E_DISABLE_CODFORM, false)
        })
    },
    [types.POST_HRMS73E_SAVE] ({ commit, dispatch }, { searchIndex, indexSelected, detail }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: 'ok',
        cancelButtonText: 'cancel',
        html: true
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms73e.postSave({ searchIndex, indexSelected, detail })
            .then((response) => {
              const data = JSON.parse(response.request.response)

              dispatch(types.RECEIVED_HRMS73E_INDEX, searchIndex)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    },
    [types.POST_HRMS73E_CANCEL] ({ commit, dispatch }, { searchIndex, dataRowsHasFlg }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmCancel'),
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel'),
        html: true
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms73e.postDelete({ searchIndex, dataRowsHasFlg })
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRMS73E_INDEX, searchIndex)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hrms73e/index.js